import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import { Button, Form } from "react-bootstrap";
import {
  useGetEventSolutionsQuery,
  useUpdateNoSolutionEventMutation,
  useUpdateSolutionEventMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";

export default function EventUpdateModal({ eventData, eventSolution }) {
  const [severity, setSeverity] = useState("low");
  const [name, setName] = useState(eventData.Label);
  const [description, setDescription] = useState(eventData.Description || "");
  const [updateEventWithSolution] = useUpdateSolutionEventMutation();
  const [updateNoSolutionEvent] = useUpdateNoSolutionEventMutation();
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (handleClose) => {
    const update = eventSolution?.Features?.some(
      (f) => f.Feature === "update-event" && f.Status === "enabled"
    )
      ? updateEventWithSolution
      : updateNoSolutionEvent;

    setLoading(true);
    await update({
      Severity: severity,
      Name: name,
      Description: description,
      SolutionClientUuid: eventSolution.Uuid,
      ID: eventData.Reference,
    }).then((res) => {
      if ("data" in res) {
        toast.success("Event updated successfully");
        handleClose();
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  };

  return (
    <MyModal
      label="Update Event"
      buttonClassName="bg-colored-reverse px-3 rounded-pill btn-sm border-0 fw-bold text-white text-nowrap p-1"
      heading="Update Event"
    >
      {({ handleClose }) => (
        <>
          <div className="position-relative bg-white p-3 rounded-2 my-3">
            <AbsoluteLoadingIndicator loading={loading} />
            <Form.Group>
              <Form.Label className="fw-bold my-2">Event name?</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <Form.Label className="fw-bold my-2">
                Event description?
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
            <div className="col mt-3">
              <div className="fw-bold fs-4">
                Alert Level:
                <span className="fw-bold text-danger">
                  {" "}
                  {severity.toUpperCase()}
                </span>
              </div>

              <div
                className="rounded-pill p-2 fw-bold  d-flex justify-content-between text-white my-3"
                style={{
                  background: `linear-gradient(
                            90deg,
                            rgba(30, 250, 0, 1),
                            rgb(255, 187, 0),
                            rgba(255, 0, 0, 1) 
                            )`,
                }}
              >
                <button
                  className="ms-2 btn text-white"
                  onClick={(e) => {
                    setSeverity("low");
                  }}
                >
                  LOW{" "}
                </button>
                <button
                  className="ms-2 btn text-white"
                  onClick={(e) => {
                    setSeverity("medium");
                  }}
                >
                  MEDIUM{" "}
                </button>
                <button
                  className="ms-2 btn text-white"
                  onClick={(e) => {
                    setSeverity("high");
                  }}
                >
                  HIGH
                </button>
                <button
                  className="ms-2 btn text-white"
                  onClick={(e) => {
                    setSeverity("critical");
                  }}
                >
                  CRITICAL
                </button>
              </div>
              <div>
                <input
                  type="range"
                  className="w-100"
                  step={1}
                  min={0}
                  max={3}
                  value={["low", "medium", "high", "critical"].indexOf(
                    severity || "low"
                  )}
                  onChange={(e) => {
                    setSeverity(
                      ["low", "medium", "high", "critical"][
                        parseInt(e.target.value)
                      ]
                    );
                  }}
                />
              </div>
            </div>{" "}
          </div>
          <div className="d-flex justify-content-end">
            <Button
              className="bg-colored-reverse px-3 rounded-pill border-0 btn-sm fw-bold mt-3 "
              onClick={() => handleUpdate(handleClose)}
              disabled={loading}
            >
              <div className="text-white"> Update Event</div>
            </Button>
          </div>
        </>
      )}
    </MyModal>
  );
}
